<template>
<div class="chapter">
<div class="inner_page">
<p class="author"><a id="page_iii"></a>MARK S. HAMM</p>
<h1 class="h1"><strong>TERRORISM AS CRIME</strong></h1>
<p class="subtitle"><em>From Oklahoma City to Al-Qaeda and Beyond</em></p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?64e61902